// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-slider-slider-navigation----slider-navigation-module---wrapper---8RchC","csNav":"src-components-slider-slider-navigation----slider-navigation-module---csNav---2DoHS","numbered":"src-components-slider-slider-navigation----slider-navigation-module---numbered---3AjuW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/slider-navigation/slider-navigation.module.css
// module id = 546
// module chunks = 168707334958949